import Mentions from './src/Mentions';
import Option from './src/Option';

Mentions.Option = Option;

export default Mentions;
